module.exports = __webpack_public_path__ + "img/epr-price@2x.26e22a11.webp";